// ============================================
// DOCUMENTOSAVISOSPANEL.JS — "Documentos de la empresa por vencer" en Mi Trabajo (Entrega 1, 2026-09-08)
// ============================================
// Solo lo ve direccion/administracion (el endpoint es soloAdmin: si responde 403 el panel no se pinta).
// Avisos 15 dias antes y al vencer: "Tu constancia de situacion fiscal vence el DD/MM — renuevala en el SAT".
// Atendido / Descartar con nota (trazabilidad). Reusa el motor de avisos (mismo job diario que garantias).

import React, { useCallback, useEffect, useState } from 'react';
import { FileWarning, Check, X } from 'lucide-react';
import { API_BASE_CLI, PP, COLOR_OSCURO, COLOR_GRIS, COLOR_GRIS_CLARO, COLOR_BORDE, estiloBotonSecundario, estiloTarjeta } from './helpersClientes';

import { authHeaders as authBase } from '../utils/storage';
const authHeaders = () => ({ ...authBase(), 'Content-Type': 'application/json' });

export default function DocumentosAvisosPanel({ onIrDatosEmpresa }) {
  const [avisos, setAvisos] = useState(null);
  const [permitido, setPermitido] = useState(true);
  const cargar = useCallback(async () => {
    try {
      const r = await fetch(`${API_BASE_CLI}/api/empresa/documentos/avisos?estado=pendiente`, { headers: authHeaders() });
      if (r.status === 401 || r.status === 403) { setPermitido(false); return; }
      const j = await r.json(); if (j.ok) setAvisos(j.avisos || []);
    } catch { /* silencioso */ }
  }, []);
  useEffect(() => { cargar(); }, [cargar]);
  const atender = async (a, estado) => {
    const nota = estado === 'descartado' ? window.prompt('Motivo (opcional):', '') : null;
    try {
      const r = await fetch(`${API_BASE_CLI}/api/empresa/documentos/avisos/${a.id}`, { method: 'PATCH', headers: authHeaders(), body: JSON.stringify({ estado, nota: nota || null }) });
      if (r.ok) cargar();
    } catch { /* */ }
  };
  if (!permitido || !avisos || avisos.length === 0) return null;
  return (
    <div style={{ ...estiloTarjeta, fontFamily: PP, borderLeft: '4px solid #9A5B00' }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: COLOR_OSCURO, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}><FileWarning size={18} color="#9A5B00" /> Documentos de la empresa por vencer ({avisos.length})</div>
      <div style={{ display: 'grid', gap: 6 }}>
        {avisos.map(a => (
          <div key={a.id} style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', padding: '8px 10px', borderRadius: 10, border: `1px solid ${COLOR_BORDE}`, background: a.tipo === 'vencido' ? '#FDF2F2' : '#FFF6E5' }}>
            <span style={{ flex: '1 1 260px', fontSize: 13, color: COLOR_GRIS }}>{a.texto}</span>
            <span style={{ fontSize: 11, color: COLOR_GRIS_CLARO }}>{a.tipo === 'vencido' ? 'Vencido' : `Faltan ${a.dias_restantes} días`}</span>
            {onIrDatosEmpresa && <button type="button" style={{ ...estiloBotonSecundario, minHeight: 40, fontSize: 12 }} onClick={onIrDatosEmpresa}>Ir a Datos de la empresa</button>}
            <button type="button" title="Atendido" style={{ ...estiloBotonSecundario, minHeight: 40, display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12 }} onClick={() => atender(a, 'atendido')}><Check size={14} /> Atendido</button>
            <button type="button" title="Descartar" style={{ ...estiloBotonSecundario, minHeight: 40, display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12 }} onClick={() => atender(a, 'descartado')}><X size={14} /> Descartar</button>
          </div>
        ))}
      </div>
    </div>
  );
}
